<div class="zeva-page" [@routerTransition]="getState(o)">
  <router-outlet #o="outlet"></router-outlet>
  <core-footer />
</div>
